'use client'

import React from 'react'
import { Theme, useMediaQuery } from '@mui/material'
import { LayoutWrapper, BgImage, ContentBox } from './layout.styled'

import shopBackgroundImage from 'src/images/shop-background.jpg'

interface Props {
  children: React.ReactNode
}

const Layout: React.FC<Props> = ({ children }) => {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'))

  return (
    <LayoutWrapper>
      <ContentBox>
        {!isMobile && <BgImage fill priority src={shopBackgroundImage} alt="Shop background" />}
        {children}
      </ContentBox>
    </LayoutWrapper>
  )
}

export default Layout
